import {
    makeActionCreator,
    JOBSEARCH_ADD,
    JOBSEARCH_SUCCESS,
    JOBSEARCH_FAILURE,
    JOBSEARCH_DELETE
} from '../actionTypes'

export const jobSearchAdd = makeActionCreator(JOBSEARCH_ADD,'university','faculty','department','jobs','image','oldJobs','name')

export const jobSearchSuccess = makeActionCreator(JOBSEARCH_SUCCESS)
export const jobSearchFailure = makeActionCreator(JOBSEARCH_FAILURE)
export const jobSearchDelete = makeActionCreator(JOBSEARCH_DELETE, 'jobId', 'jobs')


// WEBPACK FOOTER //
// ./src/search/action.js